<template>
    <div class="house-card" @click="toDetail">
        <div class="img-content">
            <img :src="`/api/v1/file/${item.cover}`" alt="" class="house-card-img">
        </div>
        <div class="card-name" :title="item.title">{{item.title}}</div>
        <div v-if="showAddress" class="card-address">{{item.address}}</div>
        <div v-else class="card-address"></div>
        <div class="card-bottom">
            <div class="card-sub f-18">人均消费：
                <span class="f-14">{{item.currency}}</span>￥
                <span class="price-text">{{item.per_capita||item.price|parseNum}}</span>
            </div>
            <div class="evaluate-content">
                <el-rate :value="+item.star|| 0"
                         disabled
                         show-score
                         disabled-void-color="#cccccc"
                         text-color="#ff9900"
                         style="display: flex;justify-content: flex-start;align-items: center"
                         score-template="{value}"></el-rate>
                <div>{{item.evaluate_count || item.evaluate_num || 0}} 评价</div>
                <div>{{item.view_count}} 浏览</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StoryCard",
        props:{
            item: {
                type: Object,
                default(){
                    return {}
                }
            },
            type:{
              type: Number,
              default: 1
            },
            showAddress:{
                type: Boolean,
                default: true
            }
        },
        methods:{
            toDetail(){
                let path = ''
                if(this.type === 1){
                    path = '/hotSpringDetail'
                }else if(this.type === 2){
                    path = '/sceneDetail'
                }else if(this.type === 3){
                    path = '/cateDetail'
                }
                this.$router.push({path, query:{id: this.item.id}})
            }
        }
    }
</script>

<style scoped lang="less">
    .house-card{
        width: 280px;
        height: 330px;
        margin: 10px;
        box-sizing: border-box;
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 6px;
        overflow: hidden;
        &:hover{
            .house-card-img{
                transform: scale(1.1);
            }
            .card-name{
                color: #e44646;
            }
        }

        .img-content{
            width: 100%;
            height: 192px;
            overflow: hidden;
            .house-card-img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: 0.3s;
            }
        }
        .card-name{
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            white-space: nowrap;
            font-size: 18px;
            height: 34px;
            line-height: 34px;
            padding: 0 10px;
            box-sizing: border-box;
        }
        .card-address{
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            white-space: nowrap;
            font-size: 14px;
            padding: 0 10px;
            box-sizing: border-box;
            color: #9da6aa;
            min-height: 18px;
        }
        .card-bottom{
            padding: 0 10px;
            width: 100%;
            box-sizing: border-box;
            position: relative;
        }
        .evaluate-content{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #949494;
            font-size: 14px;
        }
        .card-sub{
            color: #949494;
            font-size: 14px;
            text-align: left;
            margin: 10px 0;
        }
        .price-text{
            font-size: 20px;
            color: #e44646;
        }
    }
</style>
